<template>
    <DashboardKPIs
            :currency="currency"
            :kpi-data="kpiDataComputed"
    ></DashboardKPIs>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import externalParsedProps from '@/mixins/externalParsedProps';
import DashboardKPIs from '../pages/dashboard/DashboardKPIs.vue';

const parsedProps = ['kpiData'];

export default {
    name: 'DashboardKpisEx',
    mixins: [
        externalParsedProps(DashboardKPIs.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(DashboardKPIs.props, parsedProps),
    components: { DashboardKPIs }
};
</script>
